/**
 * Usage:
 *
 * data-sw-shapejs-creator-form=<creatorId>
 *
 */

var $ = require('js/sw-jquery/sw-jquery');

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-shapejs-creator-form]').each(function() {
    var $el = $(this);

    require([
      'js/lib/models/ModelManager',
      'js/lib/views/ShapeJS/ShapeJsParamFormView'
    ], function(ModelManager, ShapeJsParamFormView) {

      var creatorId = $el.data('swShapejsCreatorForm');
      var shapeJsModel = ModelManager.getShapeJs(creatorId);

      new ShapeJsParamFormView({
        stateId: creatorId,
        el: $el,
        model: shapeJsModel
      });

    });

  });

};
